// extracted by mini-css-extract-plugin
module.exports = {"cardcontainer":"countries_cardcontainer__2GaNl"};